var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"order-food-table-drag-btn"},[(_vm.isSorting)?_c('el-button',{class:[_vm.handlerClass],attrs:{"type":"primary","icon":"el-icon-d-caret ","circle":"","size":"mini"}}):_c('div',[_vm._v("\n    "+_vm._s(_vm.index + 1)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }